import React, { createRef, forwardRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ImageOrVideo from "../ImageOrVideo";
import { useSettings } from "../../hooks/SettingsHooks";
import { cmsAssetUrl } from "../../utils/CmsUtils";
import "./style.scss";
import EnterViewportAnimation from "../EnterViewportAnimation";

const ImageBox = forwardRef((props, ref) => {
  ref = ref || createRef({});
  const {
    backgroundImage,
    centerImage,
    theme = "black",
    textShadow = false,
    id = null,
    className = null,
    style = {},
    deferLoading = false,
    children,
    ...rest
  } = props;
  const settings = useSettings();
  const image = backgroundImage
    ? typeof backgroundImage === "object"
      ? backgroundImage
      : { path: backgroundImage, image: true }
    : {
        ...settings.default_bg_image,
        path: cmsAssetUrl(settings.default_bg_image.path)
      };

  const classes = classNames(
    "image-box",
    "theme-" + theme,
    { "text-shadow": textShadow },
    className
  );

  return (
    <div ref={ref} key={id} id={id} {...rest} className={classes} style={style}>
      {!deferLoading && (
        <ImageOrVideo
          image={image}
          className="image-box-bkg"
          centerImage={centerImage}
        />
      )}
      <div className="image-box-content-wrapper">
        <div className="image-box-content">
          <EnterViewportAnimation mode="fade-up">
            {children}
          </EnterViewportAnimation>
        </div>
      </div>
    </div>
  );
});
ImageBox.displayName = "ImageBox";

ImageBox.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  theme: PropTypes.string,
  type: PropTypes.oneOf(["fat", "medium", "slim", "full"]),
  backgroundImageUrl: PropTypes.string,
  textShadow: PropTypes.bool
};

export default ImageBox;
